<template>
  <img :style="imageStyle" :src="src" @click="click" />
</template>
<script>
export default {
  props: {
    width: {
      type: String
    },
    height: {
      type: String
    },
    src: {
      type: String
    },
    borderRadius: {
      type: String
    },
    marginLeft: {
      tyoe: String
    },
    marginRight: {
      tyoe: String
    },
    marginTop: {
      tyoe: String
    },
    marginBottom: {
      tyoe: String
    }
  },
  computed: {
    imageStyle () {
      return {
        width: this.width,
        height: this.height,
        borderRadius: this.borderRadius,
        marginLeft: this.marginLeft,
        marginRight: this.marginRight,
        marginTop: this.marginTop,
        marginBottom: this.marginBottom
      }
    }
  },
  methods: {
    click () {
      this.$emit('click')
    }
  }
}
</script>



// WEBPACK FOOTER //
// third_party/common_app/Common/ZWSComponent/Image.vue